import { render } from "./unassignedResubmittedModal.vue?vue&type=template&id=15bc7b20"
import script from "./unassignedResubmittedModal.vue?vue&type=script&lang=js"
export * from "./unassignedResubmittedModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__